<template>
    <div style="width: 100%;">
        <van-nav-bar :fixed="true" left-arrow left-text="返回" @click-left="onClickLeftBack">
            <template #right>
                <van-icon name="wap-nav" size="18" />
            </template>
        </van-nav-bar>
        <div style="width: 100%;height:50px;"></div>
        <div
            style="width: 100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 20px;">
            <my-text-one :title="teamName + '成员信息'" :textContent="teamName + '成员信息'"></my-text-one>
            <div style="height: 40px;"></div>

                <div class="list-view" :style="{ height: screenHeight }">
                    <el-row :gutter="10">
                        <el-col :span="6" v-for="(item,i) in memberList" :key="i" @click="currentIndex = i">

                            <el-card :body-style="{ padding: '0px' }">
                                <div
                                    style="width: 100%;height: 815px;display: flex;flex-direction: column;align-items: center;">
                                    <img :src="item.img" alt="" style="width: 100%;height: 680px;">
                                    <div style="width: 100%;display: flex;flex-direction: column;margin-top: 10px;" @click=" goMemberContent(i)">
                                        <label
                                            style="font-size: 18pt;color: white;margin-left: 15px;margin-bottom: 5px;">姓名：{{item.name}}</label>
                                        <label
                                            style="font-size: 18pt;color: white;margin-left: 15px;margin-bottom: 5px;">电话号码：{{item.phone}}</label>
                                        <label
                                            style="font-size: 18pt;color: white;margin-left: 15px;margin-bottom: 5px;">加入时间：{{item.createTime}}</label>
                                    </div>

                                </div>
                            </el-card>
                        </el-col>

                    </el-row>
                </div>
                <!-- <el-tabs type="border-card">
                <el-tab-pane label="配置管理">
                    <div style="height: 700px;background-color: white;"></div>
                </el-tab-pane>
                <el-tab-pane label="角色管理">角色管理</el-tab-pane>
                <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
            </el-tabs> -->
            </div>
            <div class="kuang">
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
            </div>
        </div>
    </div>

</template>

<script>
import LivePlayer from '@liveqing/liveplayer'
import MyTextOne from "@/components/MyTextOne.vue";
export default {
    name: 'MemberList',
    components: {
        LivePlayer,
        MyTextOne,
    },
    data() {
        return {
            // 屏幕宽度
            screenWidth: window.screen.width,
            // 屏幕高度
            screenHeight: (window.screen.height - 240) + "px",
            // 分屏布局
            playerNum: 20,

            memberList: [
                { title: '视频1', music: '' },
            ],
            dataForm: {
                key: ''
            },

            dataListLoading: false,
            addOrUpdateVisible: false,
            activeName: '1',
            selectTabName: 1,
        };
    },
    computed: {
      teamName () {
        return (this.$store && this.$store.state.brand && this.$store.state.brand.teamName) || '音愈童心'
      }
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.$http({
                url: this.$http.adornUrl('/app/member/list'),
                method: 'get',
                params: this.$http.adornParams({
                    'page': this.pageIndex,
                    'limit': this.pageSize,
                    'key': this.dataForm.key
                })
            }).then(({ data }) => {
                if (data && data.code === 0) {
                    this.memberList = data.page.list
                    this.playerNum = data.page.totalCount
                    console.log(this.memberList);

                } else {
                    this.memberList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        goMemberContent(index) {
            console.log(index);
            let data = this.memberList[index]
            console.log(data);
            this.$router.push({
                name: "MemberContent",
                params: {
                    data: data
                }
            })

        },
        onClickLeftBack() {
            this.$router.back()
        },
        handleClick(tab, event) {
            this.selectTabName = Number(tab.name)
            console.log(this.selectTabName, this.memberList[0].type);
        },

    },
    mounted() {
        this.getDataList()

    },
    created() {
    }
}
</script>
<style lang="less" scoped>
.van-nav-bar {
    background-color: #00000000;
}

/* 需要滚动条隐藏的列表 */
.list-view {
    width: 95%;
    // height: 630px;
    margin-top: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
    display: none;
}

/deep/ .el-tabs__nav {
    // width: 10px;
    //   font-size: 29px;
    // line-height: 55px;
    height: 35px;
}


::v-deep .el-tabs__item.is-active {
    color: skyblue; //选中
    opacity: 1;
}

::v-deep .el-tabs__item:hover {
    color: skyblue; //悬浮
    cursor: pointer;
    opacity: 1;
}

/deep/.el-tabs__item {
    /* 修改为您想要的文字大小 */
    font-size: 10pt !important;
    color: #fff;
    font-weight: bold;
}

/deep/.el-tabs__nav-wrap::after {
    /* 去掉下划线 */
    position: static !important;
}

/* 下划线颜色 */
::v-deep .el-tabs__active-bar {
    background-color: skyblue;
}

.el-card {
    background-color: rgba(255, 255, 255, 0.4) !important;

    box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6) !important;

    backdrop-filter: blur(50px) !important;
    border: none !important;
    border-radius: 5px !important;
}

.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
    margin-bottom: 20px
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

/**背景 **/

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.kuang {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
    position: absolute;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: inset 0 0 8px #fff;
    animation: flutter 10s infinite;
    opacity: 0;
}

@keyframes flutter {
    0% {
        transform: translateX(0);
        bottom: -100px;
        opacity: 1;
    }

    50% {
        transform: translateX(100px);
        opacity: 0.5;
    }


    100% {
        transform: translateX(0px);
        bottom: 100%;
        opacity: 0;

    }
}

.bubble:nth-child(1) {
    left: -10%;
    width: 50px;
    height: 50px;
    animation-duration: 9s;
    animation-delay: 0.1s;
}

.bubble:nth-child(2) {
    left: 15%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1.5s;

}

.bubble:nth-child(3) {
    left: 20%;
    width: 60px;
    height: 60px;
    animation-duration: 10s;



}

.bubble:nth-child(4) {
    left: 30%;
    width: 30px;
    height: 30px;
    animation-duration: 5.5s;
    animation-delay: 1.5s;

}

.bubble:nth-child(5) {
    left: 40%x;
    width: 50px;
    height: 50px;
    animation-duration: 12s;



}

.bubble:nth-child(6) {
    left: 50%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1s;

}

.bubble:nth-child(7) {
    left: 60%;
    width: 40px;
    height: 40px;
    animation-duration: 8s;
    animation-delay: 1s;

}

.bubble:nth-child(8) {
    left: 65%;
    width: 60px;
    height: 60px;
    animation-duration: 15s;

}

.bubble:nth-child(9) {
    left: 80%;
    width: 55px;
    height: 55px;
    animation-duration: 9s;
    animation-delay: 0.5s;

}

.bubble:nth-child(10) {
    left: 100%;
    width: 40px;
    height: 40px;
    animation-duration: 12s;

}

/** 发光字体 */
.nav {
    position: relative;
    font: 10 12pt '';
    color: #ffffff;
    cursor: pointer;
    font-weight: bold;
}

.nav:hover span {
    color: #FFFFFF;
    text-shadow: 0 0 10px #FFFFFF,
        0 0 20px #FFFFFF,
        0 0 30px #FFFFFF,
        0 0 50px #FFFFFF,
        0 0 70px #FFFFFF,
        0 0 90px #FFFFFF;

}
</style>
